import flagManager from '@/lib/FlagsManager'

export default {
  install(Vue) {
    Vue.prototype.$isFeatureEnabled = function(feature, account) {
      const user = account || this.$store?.state?.access?.account
      return flagManager.isFeatureEnabled(feature, user)
    }

    Vue.prototype.$getFeatureVariable = function(feature, variable, account) {
      const user = account || this.$store?.state?.access?.account
      return flagManager.getFeatureVariable(feature, variable, user)
    }

    Vue.prototype.$getFeatureParams = function(feature, account) {
      const user = account || this.$store?.state?.access?.account

      return flagManager.getFeatureParams(feature, user)
    }

    Vue.prototype.$featuresKeys = flagManager.FEATURES

    Vue.prototype.$onFeatureFlagsReady = function() {
      return flagManager.onReady()
    }
  },
}
